export default "__VITE_ASSET__2acb6833__"